import { Lightning, Utils } from '@lightningjs/sdk'

export default class Loader2 extends Lightning.Component {
  static _template() {
    return {
      Spinner: {
        w: 80,
        h: 80,
        rotation: true,
        src: Utils.asset('images/loaderSpinner.png'),
      },
    }
  }

  _init() {
    this._spinAnimation = this.animation({
      duration: 1,
      repeat: -1,
      stopMethod: 'finish',
      actions: [{ t: 'Spinner', p: 'rotation', v: { sm: 0, 0: { v: Math.PI * 2 }, 1: { v: 0 } } }],
    })
  }

  _inactive() {
    this._spinAnimation.stop()
  }
  set loaderSize({ width = 80, height = 80 }) {
    this.tag('Spinner').patch({
      w: width,
      h: height,
    })
  }

  _active() {
    this._spinAnimation.start()
  }

  start() {
    this.patch({
      smooth: { alpha: [1, { duration: 0.3, delay: 0.9 }] },
    })

    this._spinAnimation.start()
  }

  stop() {
    this.patch({
      smooth: { alpha: [0, { duration: 0.2 }] },
    })

    this._spinAnimation.stop()
  }
}
